import { render, staticRenderFns } from "./patientMedicalRecord.vue?vue&type=template&id=2ecbaf10&scoped=true"
import script from "./patientMedicalRecord.vue?vue&type=script&lang=js"
export * from "./patientMedicalRecord.vue?vue&type=script&lang=js"
import style0 from "./patientMedicalRecord.vue?vue&type=style&index=0&id=2ecbaf10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecbaf10",
  null
  
)

export default component.exports